<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="水厂名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plName">
              <a-input v-model="model.plName" placeholder="请输入水厂名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="设计日处理量" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plCapacity">
              <a-input-number v-model="model.plCapacity" placeholder="请输入设计日处理量" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plLeader">
              <a-input v-model="model.plLeader" placeholder="请输入负责人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="投运状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plStatus">
              <a-input v-model="model.plStatus" placeholder="请输入投运状态"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="投运日期" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plDate">
              <j-date placeholder="请选择投运日期" v-model="model.plDate"  style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="自定义LOGO" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plLogo">
              <j-image-upload isMultiple  v-model="model.plLogo" ></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="水厂简介" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="plDesc">
              <a-textarea v-model="model.plDesc" rows="4" placeholder="请输入水厂简介" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="location">
              <a-input v-model="model.location" placeholder="请输入地址"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="坐标(百度)" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="baiduCoord">
              <a-input v-model="model.baiduCoord" placeholder="请输入坐标(百度)"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'SewegePlantListForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           plName: [
              { required: true, message: '请输入水厂名称!'},
           ],
        },
        url: {
          add: "/tech/sewegePlantList/add",
          edit: "/tech/sewegePlantList/edit",
          queryById: "/tech/sewegePlantList/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>